let Api = {
	// 合格证
	"SYSTEMCONFIG_REGPROTOCOLSAVE": "/b2b/w/systemConfig/regProtocolSave", //协议配置保存
	"SYSTEMCONFIG_GETREGPROTOCOLINFO": "/b2b/w/systemConfig/getRegProtocolInfo", //协议配置详细信息
	"SYSTEMCONFIG_GOODSINFOSAVE": "/b2b/w/systemConfig/goodsInfoSave", //运营配置-商品配置信息保存
	"SYSTEMCONFIG_GETGOODSINFO": "/b2b/w/systemConfig/getGoodsInfo", //运营配置-商品配置查询处理
	"SYSTEMTAG_FINDPAGELIST": "/b2b/w/systemTag/findPageList", //标签配置-商品列表
	"SYSTEMTAG_SAVEORUPDATE": "/b2b/w/systemTag/saveOrUpdate", //标签配置-新增或修改
	"SYSTEMTAG_FINDINFO": "/b2b/w/systemTag/findInfo", //标签配置-查询详细信息
	"SYSTEMTAG_DEL": "/b2b/w/systemTag/del", //标签配置-删除
	"DEADLINEMAGE_LIST1": "/b2b/w/DeadLineMage/list", //查询期限配置列表
	"DEADLINEMAGE_UPDATE1": "/b2b/w/DeadLineMage/update", //编辑期限管理
}
module.exports = Api